/** 平台与旧客户端的能力元数据；端点描述协议，不代表模型能力。 */
export interface ModelCapabilityMetadata {
  capabilities?: readonly string[] | string;
  supportsImage?: boolean;
  supports_image?: boolean;
  endpointType?: number;
  endpoint_type?: number;
  supportedEndpointTypes?: string[];
  supported_endpoint_types?: string[];
}

/** 将数组或 CSV 标签统一为去空、去重、小写数组。 */
export function readModelCapabilities(model: ModelCapabilityMetadata): string[] {
  const raw = model.capabilities;
  const values = typeof raw === 'string' ? raw.split(',') : Array.isArray(raw) ? raw : [];
  return [...new Set(values.filter(value => typeof value === 'string').map(value => value.trim().toLowerCase()).filter(Boolean))];
}

/** 优先采用明确能力；只有无标签旧模型才回退手工开关或旧 vision 端点。 */
export function modelSupportsImage(model: ModelCapabilityMetadata): boolean {
  const caps = readModelCapabilities(model);
  if (caps.length) return caps.includes('image-text-to-text');
  if ((model.endpointType ?? model.endpoint_type) === 4) return false;
  const flag = model.supportsImage ?? model.supports_image;
  if (typeof flag === 'boolean') return flag;
  return (model.supportedEndpointTypes ?? model.supported_endpoint_types ?? []).includes('vision');
}

/** 主对话模型的统一判定，供页面选择与服务端 Agent 执行授权共同使用。 */
export function isPrimaryChatModel(model: { capabilities?: string[] | string; isPrimary?: boolean }): boolean {
  if (model.isPrimary === false) return false;
  if (model.isPrimary === true) return true;
  const caps = new Set(readModelCapabilities(model));
  if (caps.size === 0) return true;
  if (caps.has('text-generation')) return true;
  // 仅有生成类/发现 API capability 的辅助模型
  const auxiliaryOnly = ['text-to-image', 'image-to-image', 'text-to-video', 'image-to-video', 'text-to-speech', 'automatic-speech-recognition', 'audio-text-to-text'];
  return !auxiliaryOnly.some((c) => caps.has(c));
}
